import React, { useRef, useState } from "react";
// Importez les icônes dont vous avez besoin (Play, Pause, VolumeX, Volume2, etc.)
// selon https://lucide.dev/icons
import { Play, Pause, Volume2, VolumeX } from "lucide-react";
import "../styles/VideoBanner.css";

const VideoBanner = ({source, setAutoPlay = false}) => {
  // État pour la gestion du "playing" et du "muted"
  const [isPlaying, setIsPlaying] = useState(setAutoPlay);
  const [isMuted, setIsMuted] = useState(true);

  // useRef pour pointer vers la balise <video> et pouvoir la contrôler
  const videoRef = useRef(null);

  // Lance ou met en pause la vidéo
  const handlePlayPause = () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  // Active ou coupe le son
  const handleMuteToggle = () => {
    if (!videoRef.current) return;

    const nextMutedValue = !isMuted;
    videoRef.current.muted = nextMutedValue;
    setIsMuted(nextMutedValue);
  };

  return (
    <div className="VideoBanner_video-banner">
      <video
        ref={videoRef}
        className="VideoBanner_background-video"
        autoPlay={setAutoPlay}
        loop
        muted={isMuted}
        playsInline
      >
        <source src={source} type="video/mp4" />
        Votre navigateur ne supporte pas la vidéo.
      </video>

      <div className="VideoBanner_overlay" />

      {/* Boutons en bas à droite */}
      <div className="VideoBanner_controls">
        <button onClick={handlePlayPause}>
          {isPlaying ? <Pause /> : <Play />}
        </button>

        <button onClick={handleMuteToggle}>
          {isMuted ? <VolumeX /> : <Volume2 />}
        </button>
      </div>
    </div>
  );
};

export default VideoBanner;
